import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { RequireRole } from '@/core/permissions';

const TestsPage = lazy(() => import('./pages/TestsPage').then(m => ({ default: m.TestsPage })));
const TestBuilderPage = lazy(() =>
  import('./pages/TestBuilderPage').then(m => ({ default: m.TestBuilderPage }))
);
const TestAttemptsPage = lazy(() =>
  import('./pages/TestAttemptsPage').then(m => ({ default: m.TestAttemptsPage }))
);
const AttemptGradingPage = lazy(() =>
  import('./pages/AttemptGradingPage').then(m => ({ default: m.AttemptGradingPage }))
);
const AttemptPage = lazy(() =>
  import('./pages/AttemptPage').then(m => ({ default: m.AttemptPage }))
);

/**
 * Assessment routes. `/tests` is shared by staff and pupils (one endpoint, two
 * serializers); authoring and the grading queue are staff-only, and taking an
 * attempt is pupil-only — mirroring the backend's own role gates (ADR-013).
 * Parents have no assessment surface (the API returns 403 for them).
 */
export const assessmentRoutes = (
  <>
    <Route element={<RequireRole roles={['admin', 'teacher', 'pupil']} />}>
      <Route path="/tests" element={<TestsPage />} />
    </Route>
    <Route element={<RequireRole roles={['admin', 'teacher']} />}>
      <Route path="/tests/:publicId/edit" element={<TestBuilderPage />} />
      <Route path="/tests/:publicId/attempts" element={<TestAttemptsPage />} />
      <Route path="/attempts/:publicId/grade" element={<AttemptGradingPage />} />
    </Route>
    <Route element={<RequireRole roles={['pupil']} />}>
      <Route path="/attempts/:publicId" element={<AttemptPage />} />
    </Route>
  </>
);
